import React from "react";
import Chip from "@material-ui/core/Chip";
import { makeStyles } from "@material-ui/core/styles";
import { STATUS, statusLabels } from "../mockData";

const useStyles = makeStyles((theme) => ({
  chip: {
    fontWeight: 600,
    minWidth: 96,
  },
  pending: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.contrastText,
  },
  approved: {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.contrastText,
  },
  rejected: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.contrastText,
  },
}));

// این کامپوننت وضعیت هر درخواست را با رنگ متناسب نمایش می‌دهد
export default function StatusChip({ status }) {
  const classes = useStyles();

  const statusClassMap = {
    [STATUS.PENDING]: classes.pending,
    [STATUS.APPROVED]: classes.approved,
    [STATUS.REJECTED]: classes.rejected,
  };

  return (
    <Chip
      size="small"
      label={statusLabels[status]}
      className={`${classes.chip} ${statusClassMap[status]}`}
    />
  );
}
